import { render, staticRenderFns } from "./academic-report.vue?vue&type=template&id=fc23fa9e"
import script from "./academic-report.vue?vue&type=script&lang=js"
export * from "./academic-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports